import type {EntryPoint} from 'react-relay'

import type {CreatePipelinePageComponent} from './CreatePipelinePage'

import {makeResource} from 'src/utils/makeResource'

export const CreatePipelinePageEntryPoint: EntryPoint<CreatePipelinePageComponent> = {
  root: makeResource(
    'CreatePipelinePage',
    () => import(/* webpackChunkName: "CreatePipelinePage" */ './CreatePipelinePage'),
  ),
  getPreloadProps: () => ({}),
}
